<template>
    <div class="similar_rooms">
        <div class="main_title t_style5 l_blue s_title a_left">
            <div class="c_inner">
                <h2 class="c_title">SIMILAR ROOMS</h2>
            </div>
        </div>
        <div class="row">

            <div class="col-md-4">
                <article>
                    <figure>
                        <a href="room.html" class="hover_effect h_blue h_link"><img src="images/rooms/single-room.jpg" alt="Image" class="img-responsive"></a>
                        <div class="price">€99<span> night</span></div>
                        <figcaption>
                            <h4><a href="room.html">Double Room</a></h4>
                        </figcaption>
                    </figure>
                </article>
            </div>

        </div>
    </div>
</template>

<script>
    export default
    {

    }
</script>


// WEBPACK FOOTER //
// similarRooms.vue?b66d813a